module.exports = __webpack_public_path__ + "img/dab_wasim.8ef14ca1.jpg";